<template>
  <el-dialog
    :title="editId?'编辑绑定':'新增绑定'"
    :visible.sync="addDialogVisible"
    width="40%"
    center
    :close-on-click-modal="false"
    @close="dialogCloseFun"
  >
    <el-form
      ref="ruleForm"
      :model="trainForm"
      label-width="160px"
      :rules="rules"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item
            label="配置类型："
            prop="configType"
          >
            <el-select
              v-model="trainForm.configType"
              placeholder="请选择"
              @change="handlerSelect"
              :disabled="editId ? true : false"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="isShowGlass">
          <el-col :span="24">
            <el-form-item
              label="userKey"
              prop="userKey"
            >
              <el-input v-model="trainForm.userKey"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="appId"
              prop="appId"
            >
              <el-input v-model="trainForm.appId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="appkey："
              prop="appKey"
            >
              <el-input v-model="trainForm.appKey"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="appsecret："
              prop="secret"
            >
              <el-input v-model="trainForm.secret"></el-input>
            </el-form-item>
          </el-col>
        </el-col>

        <el-col v-if="isShowAi">
          <el-form-item
            label="customerNumber："
            prop="appId"
          >
            <el-input v-model="trainForm.appId"></el-input>
          </el-form-item>
          <el-form-item
            label="监控设备："
            prop="videos"
            v-if="trainForm.configType === 4"
          >
            <el-select
              v-model="trainForm.videos"
              placeholder="请选择"
              @change="handlerSelectVideo"
              multiple
            >
              <el-option
                v-for="item in videos"
                :key="item.id"
                :label="item.deviceName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
        >确定</el-button>
        <el-button @click="resetForm('ruleForm')">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>

import { Api_setting } from '@/api/api'

export default {
  props: {
    videos: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      addDialogVisible: false,
      editId: 0,
      isShowAi: false,
      isShowGlass: false,
      trainForm: {
        configType: null, // 1-智能眼镜 2-AI盒子 3-Pkpm模型
        userKey: '',
        appId: '',
        appKey: '',
        secret: '',
        videos: [],
        extendJson: '',
      },
      options: [{
        label: '智能眼镜配置',
        value: 1,
      },
      {
        label: 'AI盒子(默认版本)',
        value: 2,
      },
      {
        label: 'AI盒子(造楼机版本)',
        value: 4,
      }],
      rules: {
        configType: [{
          required: true,
          message: "请选择配置类型",
          trigger: "blur",
        }],
        userKey: [{
          required: true,
          message: "请输入userKey",
          trigger: "blur",
        }],
        appId: [{
          required: true,
          message: "请输入appId",
          trigger: "blur",
        }],
        appKey: [{
          required: true,
          message: "请输入appKey",
          trigger: "blur",
        }],
        secret: [{
          required: true,
          message: "请输入appsecret：",
          trigger: "blur",
        }],
        videos: [{
          required: true,
          message: "请选择监控设备",
          trigger: "blur",
        }],
      },
    }
  },
  methods: {
    open(val) {
      this.addDialogVisible = true
      if (val) { // 编辑
        this.editId = val.id;
        this.trainForm = {
          ...val,
          videos: val.extendJson ? JSON.parse(val.extendJson) : [],
        }
        this.handlerSelect(val.configType)
      } else {
        this.trainForm = {}
        this.editId = 0;
        this.isShowAi = false
        this.isShowGlass = false
      }
    },
    // TODO 先不调用详情，后续缺字段再调用
    async getConfigInfoFunc(val) {
      const { data: { data, statusCode } } = await Api_setting.getConfigInfo(val)
      if (statusCode === 200) {
        this.trainForm = data
      }
    },

    handlerSelect(val) {
      if (val == 1) {
        this.isShowAi = false
        this.isShowGlass = true
        this.rules.appId[0].message = '请输入appId'
      } else {
        this.isShowGlass = false
        this.isShowAi = true
        this.rules.appId[0].message = '请输入customerNumber'
      }
    },
    handlerSelectVideo() {

    },
    dialogCloseFun() {
      this.resetForm('ruleForm')
      this.addDialogVisible = false
    },
    resetForm() {
      this.trainForm = {}
      this.editId = 0;
      this.isShowAi = false
      this.isShowGlass = false
      // this.$refs[formName].resetFields();
      this.addDialogVisible = false
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveConfigFunc()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async saveConfigFunc() {
      const params = {
        ...this.trainForm,
        extendJson: JSON.stringify(this.trainForm.videos)
      }
      const { data: { statusCode, errors } } = await Api_setting.saveConfig(params)
      if (statusCode === 200) {
        this.addDialogVisible = false
        this.$message({
          type: "success",
          message: "添加成功!",
        });
        this.$emit('updateList')
      } else {
        this.$showMessage("失败", errors);
      }
    },
  },
}
</script>
